import React from "react";
import { Paper, Typography } from "@mui/material";

interface ErrorMessageProps {
  message?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => (
  <Paper elevation={0} sx={{ p: 4, textAlign: "center", my: 4 }}>
    <Typography variant="h6" color="error">
      {message || "Something went wrong. Please try again later."}
    </Typography>
  </Paper>
);

export default ErrorMessage;
